import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import { requestPasswordReset } from './actions'
import ResetPassword from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <ResetPassword
      {...getState().requestPasswordReset}
      requestPasswordReset={requestPasswordReset}
    />,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
